import { useState, useEffect, useRef } from "react";
import "../../styles/Updatesignature.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function UpdateSignature({isOpen, onClose,}) {
  const [doctorName, setDoctorName] = useState("");
  const [qualification, setQualification] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [currentSign, setCurrentSign] = useState(null);
  const [signFile, setSignFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      fetchSignature();
    }
  }, [isOpen]);

  const fetchSignature = async () => {
    try {
      setLoading(true);
      const user = JSON.parse(
        localStorage.getItem("user")
      );
      const doctorId = user?.id;
      const response = await fetch(
        `${BASE_URL}/api/doctor-signature/?doctor_id=${doctorId}`
      );
      if (!response.ok) {
        throw new Error("Failed to load signature");
      }
      const data = await response.json();
      setDoctorName(data.doctor_name || "");
      setQualification(data.qualification || "");
      setRegistrationNumber(data.registration_number || "");
      setCurrentSign(data.signature_url || null);
    } catch (error) {
      console.error("Fetch Signature Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSignFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const user = JSON.parse(
        localStorage.getItem("user")
      );
      const centerId = user?.center_id;
      const formData = new FormData();
      const doctorId = user?.id;
      formData.append("doctor_id", doctorId);
      formData.append("qualification", qualification);
      formData.append("registration_number", registrationNumber);

      if (signFile) {
        formData.append("signature", signFile);
      }
      const response = await fetch(
        `${BASE_URL}/api/doctor-signature/update/`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update signature");
      }
      const data = await response.json();
      setCurrentSign(
        data.signature_url || currentSign
      );
      onClose?.();
    } catch (error) {
      console.error("Update Error:", error);
    } finally {
      setLoading(false);
    }
  };
  if (!isOpen) return null;
  return (
    <div
      className="us-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          onClose?.();
        }
      }}
    >
      <div className="us-modal">

        <div className="us-header">
            <h2>Update Doctor Signature</h2>
        </div>
        <div className="us-section">
            <h3>Doctor Details</h3>
            <div className="us-grid">
              <div className="us-field">
                <label>Doctor Name</label>
                <input value={doctorName} readOnly/>
              </div>
              <div className="us-field">
                <label>Qualification</label>
                <input value={qualification} onChange={(e)=>setQualification(e.target.value)}/>
              </div>
              <div className="us-field">
                  <label>Registration No.</label>
                  <input value={registrationNumber} onChange={(e)=>setRegistrationNumber(e.target.value)}/>
              </div>
            </div>
        </div>
        <div className="us-section">
          <h3>Signature</h3>
          <div className="us-sign-row">
            <div className="us-sign-col">
              <div className="us-sign-box">
                  {previewUrl ? (
                      <img
                          src={previewUrl}
                          className="us-sign-img"
                          alt=""
                      />
                  ) : (
                      "New Signature"
                  )}
              </div>
            </div>
            <div className="us-sign-col">
              <div className="us-sign-box">
                  {currentSign ? (
                      <img
                          src={currentSign}
                          className="us-sign-img"
                          alt=""
                      />
                  ) : (
                      "No Signature"
                  )}
              </div>
            </div>
          </div>
          <button className="us-upload-btn" onClick={() => fileInputRef.current?.click()}>
              Upload Signature
          </button>
          <input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFileChange}/>
          <span className="us-file-name">
              {signFile?.name || "No file selected"}
          </span>
        </div>

        <div className="us-footer">
            <button
                className="us-cancel-btn"
                onClick={onClose}
            >
                Cancel
            </button>
            <button
                className="us-save-btn"
                onClick={handleSubmit}
            >
                Save Changes
            </button>
        </div>
      </div>
    </div>
  );
}